import request from '@/utils/request'

export function getGoodsInfo() {
  return request({
    url: '/shop/goodsForCarCode',
    method: 'get',
  })
}

export function dobuyCarCode(data) {
  return request({
    url: '/shop/buyCarCode',
    method: 'post',
    data,
  })
}
